import {  useState } from "react";
import { CardTaps } from "../../../../../../../modules/theme/Component/CardTaps";
import { _AccountINFORPO } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { AmortizationCreditInfo } from "./AmortizationCreditInfo";
import { HistoryCreditInfo } from "./HistoryCreditInfo";

interface Props {
    _idAccount: number
    Credit: any;
}

export const DetailsActiveCredits = ({ _idAccount, Credit }: Props) => {

    const [indexTap, setIndexTap] = useState(0);

    const taps = [
        { id: 0, name: 'Amortización del Credito', disable: false },
        { id: 1, name: 'Historial del Credito', disable: false }
    ];

    return (
        <div className="row">
            <div className="col-md-12">
                <CardTaps index={indexTap} taps={taps} updateIndex={setIndexTap}>
                    <div className="row">
                        {indexTap === 0 &&
                            <div className="col-md-12">
                                <AmortizationCreditInfo Credit={Credit} _idAccount={_idAccount} />
                            </div>
                        }
                        {indexTap === 1 &&
                            <div className="col-md-12">
                                <HistoryCreditInfo Credit={Credit} _idAccount={_idAccount} />
                            </div>
                        }

                    </div>
                </CardTaps>
            </div>
        </div>
    )
}